import Manage from "@/views/fileStorage/s3/Manage.vue";
import EmptyLayout from "@/views/layouts/EmptyLayout.vue";

const routes = [
  {
    path: '/filestorage',
    component: EmptyLayout, // Change the desired Layout here
    meta: {requiresAuth: true},
    children: [
      {
        path: 'manage',
        component: Manage,
        name: 'FileStorageManage',
        meta: {
          permission: true
        }
      },
    ]
  }
];

export default routes;
